<template>
  <div class="card">
    <div class="card-header">
      <h1 class="card-title">
        Expert Pending Payments
      </h1>
    </div>

    <div class="card-body">
      <div class="mb-3 d-flex align-items-center flex-wrap gap-3">
        <b-spinner
          v-if="fetchingPendingList"
          type="grow"
          variant="primary"
        />
        <payment-request-date-filter
          :key="filterResetKey"
          :start-date="currentStartDate"
          :end-date="currentEndDate"
          @update-date-range="updateDateRange"
        />
        <div style="min-width: 220px;">
          <company-multiselect
            ref="companyMultiselect"
            companies-url="/admin/credit-tracking/api/companies"
            @input="updateCompanyFilter"
          />
        </div>
        <div class="d-flex align-items-center gap-2">
          <label
            class="form-label text-uppercase small text-muted fw-semibold mb-0"
            for="pending-credit-type-filter"
          >Credit Type</label>
          <select
            id="pending-credit-type-filter"
            v-model="creditType"
            class="form-select form-select-sm"
            :class="{ 'border-active': creditType !== '__all__' }"
          >
            <option value="__all__">
              All credits
            </option>
            <option value="normal">
              Project
            </option>
            <option value="head_hunting">
              Headhunting
            </option>
          </select>
        </div>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          @click="resetFilters"
        >
          Reset
        </button>
      </div>

      <payment-request-list-table
        :request-list="filteredPendingList"
        :editable="editable"
        @fetch-requests="getPendingList"
      />
    </div>
  </div>
</template>

<script>
import PaymentRequestListTable from "./elements/PaymentRequestListTable.vue";
import PaymentRequestDateFilter from "./elements/PaymentRequestDateFilter.vue";
import CompanyMultiselect from "../shared/CompanyMultiselect.vue";
import moment from "moment-timezone";

export default {
    name: "ExpertPendingPaymentList",
    components: {PaymentRequestDateFilter, PaymentRequestListTable, CompanyMultiselect},
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        startDate: {
            type: String,
            required: false,
            default: ''
        },
        endDate: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        const defaultStart = this.startDate || moment().startOf('month').format('YYYY-MM-DD')
        const defaultEnd = this.endDate || moment().endOf('month').format('YYYY-MM-DD')

        return {
            pendingList: [],
            fetchingPendingList: false,
            selectedCompanyId: null,
            creditType: '__all__',
            currentStartDate: defaultStart,
            currentEndDate: defaultEnd,
            filterResetKey: 0
        }
    },
    computed: {
        filteredPendingList() {
            if (this.creditType === '__all__') return this.pendingList

            const flag = this.creditType === 'head_hunting' ? 1 : 0

            return this.pendingList.filter((request) => Number(request.head_hunting) === flag)
        }
    },
    mounted() {
        this.getPendingList()
    },
    methods: {
        updateDateRange(start, end) {
            this.currentStartDate = start
            this.currentEndDate = end
            this.getPendingList(start, end)
        },
        updateCompanyFilter(company) {
            this.selectedCompanyId = company?.id ?? null
            this.getPendingList(this.currentStartDate, this.currentEndDate)
        },
        resetFilters() {
            this.$refs.companyMultiselect.reset()
            this.selectedCompanyId = null
            this.creditType = '__all__'
            this.currentStartDate = moment().startOf('month').format('YYYY-MM-DD')
            this.currentEndDate = moment().endOf('month').format('YYYY-MM-DD')
            this.filterResetKey++
            this.getPendingList()
        },
        async getPendingList(startDate = this.currentStartDate, endDate = this.currentEndDate) {
            try {
                this.fetchingPendingList = true
                const result = (await axios.get('/admin/credit-tracking/api/pending-experts', {
                    params : {
                        start_date: startDate,
                        end_date: endDate,
                        company_id: this.selectedCompanyId
                    }
                }))
                this.pendingList = result.data.data
            } catch (error) {
                console.log(error);
            } finally {
                this.fetchingPendingList = false
            }
        }
    }
}
</script>

<style scoped>
.border-active {
    border-color: #153c4a !important;
}
</style>
